var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../../core/runtime/src';
import { Button } from '../../../button/src';
import { getCounter } from '../helpers/s3-config';
import { Table, TableSelection, TableFiltering, TablePagination, TableSorting } from '../../../table/src';
export var S3Selection = AwsUi.__addComponent('awsui-s3-selection', {
    releaseStatus: 'internal',
    properties: {
        loading: {
            type: 'boolean'
        },
        itemsType: {
            type: 'string'
        },
        columnDefinitions: {
            type: 'array',
            itemTypes: [
                {
                    type: 'object',
                    objectType: 'Table.ColumnDefinition',
                    itemType: 'Table.Item'
                }
            ]
        },
        sortableColumns: {
            type: 'array',
            itemTypes: ['string']
        },
        isItemDisabled: {
            type: 'function',
            functionType: 'TableSelection.disablingFunction',
            functionGenericType: 'Table.Item'
        },
        items: {
            type: 'array',
            itemTypes: ['Table.Item']
        },
        selectedItems: {
            type: 'array',
            itemTypes: ['Table.Item']
        },
        visibleColumns: {
            type: 'array',
            itemTypes: ['string']
        },
        pageSize: {
            type: 'integer'
        },
        pagesCount: {
            type: 'integer'
        },
        currentPageIndex: {
            type: 'integer'
        },
        openEnd: {
            type: 'boolean'
        },
        totalItemsCount: {
            type: 'integer'
        },
        filteringText: {
            type: 'string'
        },
        filteringLabel: {
            type: 'string'
        },
        sortingColumn: {
            type: 'string'
        },
        sortingDescending: {
            type: 'boolean'
        },
        onPaginationChange: {
            type: 'function',
            functionType: 'S3ResourceSelector.PaginationChange'
        },
        onFilteringChange: {
            type: 'function',
            functionType: 'S3ResourceSelector.FilteringChange'
        },
        onSortingChange: {
            type: 'function',
            functionType: 'S3ResourceSelector.SortingChange'
        },
        onSelectionChange: {
            type: 'function',
            functionType: 'S3ResourceSelector.SelectionChange'
        },
        onRefresh: {
            type: 'function',
            functionType: 'S3ResourceSelector.Refresh'
        },
        i18nStrings: {
            type: 'object',
            objectType: 'S3ResourceSelector.I18nStrings'
        }
    },
    callbacks: {
        initialized: function () { }
    },
    render: function () {
        var _a = this, itemsType = _a.itemsType, columnDefinitions = _a.columnDefinitions, sortableColumns = _a.sortableColumns, isItemDisabled = _a.isItemDisabled, loading = _a.loading, items = _a.items, selectedItems = _a.selectedItems, visibleColumns = _a.visibleColumns, onRefresh = _a.onRefresh, onSelectionChange = _a.onSelectionChange, pagesCount = _a.pagesCount, pageSize = _a.pageSize, currentPageIndex = _a.currentPageIndex, openEnd = _a.openEnd, totalItemsCount = _a.totalItemsCount, filteringText = _a.filteringText, filteringLabel = _a.filteringLabel, sortingColumn = _a.sortingColumn, sortingDescending = _a.sortingDescending, onPaginationChange = _a.onPaginationChange, onFilteringChange = _a.onFilteringChange, onSortingChange = _a.onSortingChange, i18nStrings = _a.i18nStrings;
        if (!i18nStrings) {
            return null;
        }
        var itemsTypeCapitalized = itemsType.charAt(0).toUpperCase() + itemsType.substring(1);
        var stringName = i18nStrings["selection" + itemsTypeCapitalized];
        var stringLoading = i18nStrings["selection" + itemsTypeCapitalized + "Loading"];
        var stringNoItems = i18nStrings["selection" + itemsTypeCapitalized + "NoItems"];
        var placeholder = i18nStrings["selection" + itemsTypeCapitalized + "SearchPlaceholder"];
        var labelsSelection = i18nStrings["labels" + itemsTypeCapitalized + "Selection"];
        var sortingProps = {
            sortableColumns: sortableColumns,
            sortingChange: onSortingChange,
            sortingColumn: sortingColumn,
            sortingDescending: sortingDescending
        };
        var filteringProps = {
            filteringPlaceholder: placeholder,
            filteringText: filteringText,
            filteringChange: onFilteringChange,
            filteringLabel: filteringLabel,
            filteringCountTextFunction: i18nStrings.filteringCounterText
        };
        var paginationProps = __assign({ pageSize: pageSize, labels: i18nStrings.labelsPagination }, (pagesCount || openEnd
            ? { pagesCount: pagesCount, currentPageIndex: currentPageIndex, openEnd: openEnd, paginationChange: onPaginationChange, disabled: loading }
            : {}));
        var visibleColumnDefinitions = columnDefinitions.filter(function (_a) {
            var id = _a.id;
            return visibleColumns.includes(id);
        });
        var counter = getCounter(selectedItems.length, items.length, openEnd, totalItemsCount);
        return (AwsUi.__createElement(Table, { className: "awsui-s3-selection", loadingText: stringLoading, columnDefinitions: visibleColumnDefinitions, loading: loading, items: items, features: ['filtering', 'pagination', 'sorting', 'selection'], header: AwsUi.__createElement("div", { className: "awsui-s3-selection-header" },
                AwsUi.__createElement("h2", null,
                    stringName,
                    AwsUi.__createElement("span", { className: "awsui-util-header-counter" },
                        " ",
                        counter)),
                AwsUi.__createElement(Button, { className: "awsui-s3-selection-header__refresh", icon: "refresh", click: onRefresh, formAction: "none", label: i18nStrings.labelRefresh })), empty: AwsUi.__createElement("div", { className: "awsui-util-t-c" },
                AwsUi.__createElement("p", { className: "awsui-util-mb-s" }, stringNoItems)), noMatch: AwsUi.__createElement("div", { className: "awsui-util-t-c awsui-util-mv-s" },
                AwsUi.__createElement("b", null, i18nStrings.filteringNoMatches),
                AwsUi.__createElement("p", { className: "awsui-util-mb-xs" }, i18nStrings.filteringCantFindMatch)), tools: [
                AwsUi.__createElement(TableSorting, __assign({}, sortingProps)),
                AwsUi.__createElement(TableFiltering, __assign({}, filteringProps)),
                AwsUi.__createElement(TablePagination, __assign({}, paginationProps)),
                AwsUi.__createElement(TableSelection, { keepSelection: true, selectionType: "single", isItemDisabled: isItemDisabled, selectedItems: selectedItems, selectionChange: onSelectionChange, labels: labelsSelection })
            ] }));
    }
});
//# sourceMappingURL=s3-selection.js.map